export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore();
  if (userStore.isLoggedIn && userStore.user == null) {
    await userStore.fetchUserData(to.params.organization as string);
  }
});
